<template>
	<div class="navMenu">
		<el-menu :default-active="$route.name" class="el-menu-vertical-demo" :router="true">
			<el-menu-item :route="{name:'School'}" index="School">
				<i class="el-icon-wind-power"></i>
        		<span slot="title">学校管理</span>
			</el-menu-item>
			<el-menu-item :route="{name:'Studentcp'}" index="Studentcp">
				<i class="el-icon-user"></i>
        		<span slot="title">企微学生</span>
			</el-menu-item>
			<el-menu-item :route="{name:'Studenthik'}" index="Studenthik">
				<i class="el-icon-s-custom"></i>
        		<span slot="title">海康学生</span>
			</el-menu-item>
			<el-menu-item :route="{name:'Authorization'}" index="Authorization">
				<i class="el-icon-coin"></i>
        		<span slot="title">学生授权</span>
			</el-menu-item>
			<el-menu-item :route="{name:'Log'}" index="Log">
				<i class="el-icon-notebook-1"></i>
        		<span slot="title">推送日志</span>
			</el-menu-item>
			<el-menu-item :route="{name:'Order'}" index="Order">
				<i class="el-icon-set-up"></i>
        		<span slot="title">订单管理</span>
			</el-menu-item>
			<el-menu-item :route="{name:'Project'}" index="Project">
				<i class="el-icon-postcard"></i>
        		<span slot="title">收费项目</span>
			</el-menu-item>
			<el-menu-item :route="{name:'User'}" index="User">
				<i class="el-icon-monitor"></i>
        		<span slot="title">用户管理</span>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		},
		methods: {
			
		}
	}
</script>

<style lang="less">
	.el-submenu .el-menu-item{
		min-width: auto;
	}
	.el-submenu__title{
		text-align: left;
	}
	.el-menu-item{
		font-size: 14px !important;
	}
</style>
